import {shallowEqual} from 'react-redux';
import {assert} from 'assert-ts';
import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusesMap} from 'services/thesaurus/types';
import {selectSettingsPreferredLocale} from 'services/settings';
import {thesaurusApi} from 'services/thesaurus/thesaurusApi';
import {useAppSelector} from 'store/hooks';
import {useSchemaThesaurusIds} from './useSchemaThesaurusIds';

/**
 * Assumes needed thesauruses have been loaded
 * @param schema
 * @returns
 */
export const useSchemaThesauruses = (
  schema: Schema | undefined,
): ThesaurusesMap => {
  const thesaurusIds = useSchemaThesaurusIds(schema);
  const language = useAppSelector(selectSettingsPreferredLocale);

  return useAppSelector(state => {
    return thesaurusIds.reduce<ThesaurusesMap>((acc, id) => {
      acc[id] = assert(
        thesaurusApi.endpoints.getThesaurus.select({id, language})(state).data,
        `useSchemaThesauruses: missing thesaurus for id: ${id}`,
        {id},
      );
      return acc;
    }, {} as ThesaurusesMap);
  }, shallowEqual);
};
